export default class CsvPlayerInterpretationNotFoundError extends Error {}
